import { Navigate } from "react-router-dom";
import { useCmsAuth } from "../context/CmsAuthContext";
import { canAccessInformes } from "../lib/trafficReport";

/** Informe de tráfico: solo rol admin u owner con módulo informes. */
export default function CmsInformesGate({ children }) {
  const { profile, hasModule, loading } = useCmsAuth();
  if (loading) return null;
  if (!hasModule("informes") || !canAccessInformes(profile)) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
